import * as React from 'react';

import { IdTypes } from 'bundles/product-features';
import { ProductFeaturesQuery } from 'bundles/program-home/productFeatureFlags';

import _t from 'i18n!nls/program-home';

const getFilledProgramMessageComponent = ({ programId }: { programId: string }) => (
  <ProductFeaturesQuery idType={IdTypes.Program} id={programId}>
    {({ loading, features }) => {
      if (loading) {
        return <span>{_t('Loading...')}</span>;
      }

      const filledProgramCustomMessage = features.get('enterprise', 'filledProgramCustomMessage');

      return (
        <span>
          {filledProgramCustomMessage ||
            _t('Sorry, this program has been filled up. Please contact your learning team to add availability.')}
        </span>
      );
    }}
  </ProductFeaturesQuery>
);

const getFilledProgramErrorMessage = (programId: string) => getFilledProgramMessageComponent({ programId });

const getUnavailableProgramErrorMessage = () => _t('Currently not available. Please reach out to your program admin.');

export const PROGRAM_JOIN_CUSTOM_MESSAGE_ERRORS = {
  CREATE_MEMBERSHIP_USER_LIMIT_ERROR: 'CREATE_MEMBERSHIP_USER_LIMIT_ERROR',
  CREATE_MEMBERSHIP_CONTRACT_COURSES_PER_USER_LIMIT_ERROR: 'CREATE_MEMBERSHIP_CONTRACT_COURSES_PER_USER_LIMIT_ERROR',
} as const;

export const PROGRAM_JOIN_FIXED_MESSAGE_ERRORS = {
  CREATE_MEMBERSHIP_ENROLLMENT_CAP_LIMIT_ERROR: 'CREATE_MEMBERSHIP_ENROLLMENT_CAP_LIMIT_ERROR',
  CONTRACT_NOT_ACTIVE: 'CONTRACT_NOT_ACTIVE',
  CONSUMABLE_CONTRACT_NOT_AVAILABLE: 'CONSUMABLE_CONTRACT_NOT_AVAILABLE',
  CONTRACT_NOT_AVAILABLE: 'CONTRACT_NOT_AVAILABLE',
  ALREADY_A_MEMBER: 'ALREADY_A_MEMBER',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  INVALID_STATE_TO_JOIN: 'INVALID_STATE_TO_JOIN',
  MEMBERSHIP_NOT_FOUND: 'MEMBERSHIP_NOT_FOUND',
} as const;

export const PROGRAM_JOIN_ERRORS = {
  ...PROGRAM_JOIN_CUSTOM_MESSAGE_ERRORS,
  ...PROGRAM_JOIN_FIXED_MESSAGE_ERRORS,
} as const;

export default function getErrorMap(programId: string): Record<string, string | undefined | JSX.Element> {
  return {
    [PROGRAM_JOIN_ERRORS.CREATE_MEMBERSHIP_USER_LIMIT_ERROR]: getFilledProgramErrorMessage(programId),
    [PROGRAM_JOIN_ERRORS.CREATE_MEMBERSHIP_CONTRACT_COURSES_PER_USER_LIMIT_ERROR]:
      getFilledProgramErrorMessage(programId),
    [PROGRAM_JOIN_ERRORS.CREATE_MEMBERSHIP_ENROLLMENT_CAP_LIMIT_ERROR]: _t(
      'Sorry, you are unable to join the program at this time. All enrollments included in this program have been used, but more enrollments may become available later. If the problem persists, please contact your program admin.'
    ),
    [PROGRAM_JOIN_ERRORS.CONTRACT_NOT_ACTIVE]: getUnavailableProgramErrorMessage(),
    [PROGRAM_JOIN_ERRORS.CONSUMABLE_CONTRACT_NOT_AVAILABLE]: getUnavailableProgramErrorMessage(),
  };
}
